import React, { MouseEventHandler, ReactElement } from "react"
import { As, Button, CheckboxProps } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

export const pillButtonActiveColorScheme = { borderColor: "blue.400", backgroundColor: "blue.50" }

type Props = {
  title: string
  icon: string | ReactElement
  active?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  _checked?: {
    borderColor: string
    backgroundColor: string
  }
  cursor?: CheckboxProps["cursor"]
  as?: As
}

const PillButton = ({
  title, icon, active, onClick, ...rest
}: Props) => {
  const activeProps = active ? pillButtonActiveColorScheme : {}
  const iconElement = typeof icon === "string"
    ? <Icon color="blue.400" icon={icon} size={4} />
    : icon

  return (
    <Button
      backgroundColor="gray.50"
      borderRadius="2xl"
      variant="outline"
      px={2.5}
      leftIcon={iconElement}
      {...activeProps}
      onClick={onClick}
      {...rest}
      _hover={{}}
      _active={{}}
    >{title}
    </Button>
  )
}

export default PillButton
